/**
 * TRUSTED TYPES — A KET DINAMIKUSAN BETOLTOTT KULSO SZKRIPT KAPUJA.
 *
 * A produkcios CSP `require-trusted-types-for 'script'` direktivaja mellett
 * egy sima string nem irhato `HTMLScriptElement.src` ertekebe. A Meta pixel
 * es a Kvikk terkep is ilyen szkriptet tolt be, ezert egy szuk alapertelmezett
 * policy csak az altalunk tenylegesen hasznalt helyeket engedi at.
 *
 * `createHTML` es `createScript` SZANDEKOSAN nincs: a policy nem teszi
 * megbizhatova az onkenyes HTML-t vagy JavaScriptet. Az ilyen DOM-XSS sink
 * tovabbra is TypeErrort kap.
 */

interface TrustedTypesFactoryLike {
  readonly defaultPolicy?: unknown
  createPolicy(
    name: 'default',
    rules: { createScriptURL(value: string): string }
  ): unknown
}

const META_SCRIPT_ORIGIN = 'https://connect.facebook.net'
const KVIKK_SCRIPT = 'https://cdn.kvikk.hu/map/kvikkMapWidget.js'

/** Normalizal, es minden nem ismert szkriptforrast elutasit. */
export function engedelyezettScriptUrl(value: string): string {
  const url = new URL(value, location.href)

  if (url.origin === location.origin && (url.protocol === 'https:' || url.protocol === 'http:')) {
    return url.href
  }

  if (url.origin === META_SCRIPT_ORIGIN && url.protocol === 'https:') return url.href
  if (url.href === KVIKK_SCRIPT) return url.href

  throw new TypeError(`Nem engedelyezett szkriptforras: ${url.origin}`)
}

const factory = (globalThis as unknown as { trustedTypes?: TrustedTypesFactoryLike }).trustedTypes

if (factory && !factory.defaultPolicy) {
  factory.createPolicy('default', { createScriptURL: engedelyezettScriptUrl })
}
